import React from 'react'
import { useStoreActions, useStoreState } from 'easy-peasy'
import styled from 'styled-components'
import media from '../../utils/media'
import RadioText from './RadioText'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: center;
  flex-wrap: wrap;
  /* min-height: 320px; */
  ${media.mobileL`
    max-height: 100%;
    flex-wrap: nowrap;
  `}
`

export default function RadioTexts({ answers }) {
  const [{ currentValue }] = useStoreState(state => [state.quiz])
  const [{ answerQuestion }] = useStoreActions(state => [state.quiz])
  const t = useStoreState(state => state.locale.t)

  function getT(id, value) {
    if (!value.match(/[ap]\d/)) {
      if (id === undefined) {
        console.log(
          '%cTranslation error: id is required in Text Component',
          'color: red',
        )
        return null
      }
      return t(id, {})
    }
    return value
  }

  return (
    <>
      <Container>
        {answers.map(answer => {
          return (
            <RadioText
              key={answer.title}
              title={answer.title}
              value={getT(answer.title, answer.value)}
              checked={
                getT(answer.title, answer.value) === currentValue
              }
              onChange={() => {
                answerQuestion(getT(answer.title, answer.value))
              }}
            />
          )
        })}
      </Container>
    </>
  )
}
